import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntTypeProduct } from "../handBooks/typeProduct";

export class EntProcessingCapacity {
  id: number|null = null;
  region: EntTerritorialsUnits|null = null;
  area: EntTerritorialsUnits|null = null;
  territorialUnit: EntTerritorialsUnits|null = null;
  orgName: string|null = null;
  pin: string|null = null;
  ownershipType?: EntDirectoryInfoName|null = null;
  legalAddress: string|null = null;
  contactPerson: string|null = null;
  phoneNumbers: string[]|null = null;
  email: string|null = null;
  website: string|null = null;
  longitude: number|undefined = undefined;
  latitude: number|undefined = undefined;
  registerStatus: EntBasicHB|null = null;
  profiles: Profile[]|null = null;

  ownershipTypeId?: number|null = null;
  registerStatusId?: number|null = null;

  regionId?: number|null = null;
  areaId?: number|null = null;
  territorialUnitId?: number|null = null;
}

export class Profile {
  key: number | null = null;
  id: number|null = null;
  processingCapacityRegisterId: number|null = null;
  industryType?: EntBasicHB|null = null;
  rawMaterial?: EntBasicHB|null = null;
  productType?: EntTypeProduct|null = null;
  tonnesPerDay: number|null = null;
  storageCapacityTonnes: number|null = null;
  seasonality?: EntBasicHB|null = null;
  equipmentDescription: string|null = null;
  isItExport: boolean|null = null;
  certificate?: EntBasicHB|null = null;
  destinationCitizenship?: EntBasicHB|null = null;

  industryTypeId?: number|null = null;
  rawMaterialId?: number|null = null;
  productTypeId?: number|null = null;
  seasonalityId?: number|null = null;
  certificateId?: number|null = null;
  destinationCountryId?: number|null = null;
}
